import { render } from "./MdlSeleccionarArticulo.vue?vue&type=template&id=6965ea88"
import script from "./MdlSeleccionarArticulo.vue?vue&type=script&lang=js"
export * from "./MdlSeleccionarArticulo.vue?vue&type=script&lang=js"

import "./MdlSeleccionarArticulo.vue?vue&type=style&index=0&id=6965ea88&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__